import { render, staticRenderFns } from "./BankConditions.vue?vue&type=template&id=3612b0ff&scoped=true&"
import script from "./BankConditions.vue?vue&type=script&lang=js&"
export * from "./BankConditions.vue?vue&type=script&lang=js&"
import style0 from "./BankConditions.vue?vue&type=style&index=0&id=3612b0ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612b0ff",
  null
  
)

export default component.exports